/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/no-inferrable-types */
/* eslint-disable no-prototype-builtins */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable no-var */
/* eslint-disable @typescript-eslint/restrict-plus-operands */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */

import React, {useState} from 'react';

/* APP / CONTEXTOS */

import EntidadesController from '../../servicos/entidades/EntidadesController';
import {IRetornoAjaxEntidades, IEntidadesData} from '../../servicos/entidades/Entidades_FrontAPI';

/* COMPONENTES */

import TableSkeleton from '../../componentes/tabelas/TableSkeleton.tsx';
import AlertDialog, { IAlertConfirmDelegate } from '../../componentes/widgets/AlertConfirm.tsx';
import Bananinha, { IBananinhaDelegate } from '../../componentes/widgets/Bananinha.tsx';
import {ESTATUSFILTER, ETIPOFILTER, IPropsFilterObj, objFilterDefault} from '../../componentes/tabelas/TableFilter';

/* INTERFACES / ENUMERAÇÕES */

import FormDialog from './formDialog.tsx';
import ListComponent from '../../componentes/lists/_ListComponent.tsx';
import {EFORM} from '../../componentes/formularios/EFORM';

import { ColumnTypes, ETABLE, ITableFilter, ITablePaginacao, Order } from '../../componentes/tabelas/ITabelas.ts';
import { areAllValuesEmpty } from '../../AppConfig.ts';
import { isNumber } from 'lodash';
import { IFormStateEntidades } from 'src/servicos/IFormularios.ts';

interface IPageContexto
{
	_handleAdd?: any
	_handleEdit?: any
	_handleView?: any
	_handleExclude?: any
}

const PageContext = React.createContext<IPageContexto|undefined>(undefined);

const ListaSeries = () =>
{
	const EntController = new EntidadesController();
    
	const [ehCarregado, setEhCarregado] = useState<boolean>(false);
	const [deleting, setDeleting] = useState<boolean>(false);
	const [bananinhaDelegate, setBananinhaDelegate] = useState<IBananinhaDelegate|undefined>(undefined);
	const [alertConfirmDelegate, setAlertConfirmDelegate] = useState<IAlertConfirmDelegate|undefined>(undefined);
	const [listaPaginada, setListaPaginada] = useState<IEntidadesData[]|null>(null);
	const [openDialog, setOpenDialog] = React.useState(false);

	const [formEntidade, setFormEntidade] = React.useState<IFormStateEntidades>(null);

	const [pager, setPager] = useState<ITablePaginacao|null>(null);
	const [pageNumber, setPageNumber] = React.useState<number>();
	const [rowsPerPage, setRowsPerPage] = React.useState<number>(20);
	const [order, setOrder] = React.useState<Order>('desc');
	const [orderBy, setOrderBy] = React.useState<ColumnTypes | undefined>(undefined);
	const [filtroHead, setFiltroHead] = React.useState<ITableFilter | undefined>();

	const [dataFilter, setDataFilter] = React.useState<IPropsFilterObj>(objFilterDefault);
	const [drawerFilterStatus, setDrawerFilterStatus] = React.useState<ESTATUSFILTER>(ESTATUSFILTER.INICIAL);
	const [formView, setFormView] = React.useState<boolean>(false);

	const _handleAdd = () =>
	{
		const entidade: IFormStateEntidades = { programas: [] }
		setFormEntidade(entidade);
		setFormView(false)
		setOpenDialog(true);
	}
	const _handleEdit = async(entidade:IFormStateEntidades) =>
	{
		// A API de lista parece não trazer os dados filhos quando não se consulta pelo ID. Por isso, é necessário um GET pelo ID neste ponto:
		entidade = await getEdit(entidade);
		setFormEntidade(entidade);
		setFormView(false)
		setOpenDialog(true);
	}
	const _handleView = async(entidade:IFormStateEntidades) =>
		{
			entidade = await getEdit(entidade);
			setFormEntidade(entidade);
			setFormView(true)
			setOpenDialog(true);
		}
	React.useEffect(() =>
	{
		setFormEntidade(formEntidade)
	},[formEntidade])

	const _delete = React.useCallback( async (ID: string) => 
	{
		setDeleting(true);
		setEhCarregado(false);
		try
		{
			const res:IRetornoAjaxEntidades = await EntController.seriesDelete(ID);
			if (res && res.status == 200)
			{
				// Se página atual = última página e só tem 1 item na página
				if (isNumber(pageNumber) && isNumber(rowsPerPage) && pageNumber == pager.total_pages && ((pager.total_items % rowsPerPage) == 1 )) {
					setPageNumber(Math.max(1, pageNumber - 1))
				}
				
				if(listaPaginada.length > 1)
					bananinhaDelegate?.abrir("Item excluído com sucesso.", "success");
			}
			else
			{
				setEhCarregado(true);
				bananinhaDelegate?.abrir(res.message, "error");
			}
		}
		catch(e)
		{
			setEhCarregado(true);
			bananinhaDelegate?.abrir(e, "error");
		}
		finally
		{
			setDeleting(false);
		}
		return '';
	}, [bananinhaDelegate, pageNumber, pager, rowsPerPage]);
	const _handleExclude = React.useCallback((ID: string, Name: string) =>
	{
		alertConfirmDelegate?.abrir(
			"Confirme a exclusão", 
			'Deseja realmente excluir o item "' + Name + '"?',  
			(bln:any) => 
			{
				if(bln) _delete(ID)
			}
		)
	}, [alertConfirmDelegate, _delete])
	React.useEffect(() =>
	{
		if(!deleting)
		{
			getList()
		}
	},[deleting])

	const getList = async (callbackDataFilter?:IPropsFilterObj, rowsNum?:number, pageNum?:number, orderby?:string, order?:Order, sortParameter?: string) =>
	{
		try
		{
			console.log('getList', callbackDataFilter, rowsNum, pageNum, orderby, order, sortParameter);
			setEhCarregado(false);
			const res:IRetornoAjaxEntidades = await EntController.seriesList(undefined, callbackDataFilter || dataFilter, rowsNum || rowsPerPage, pageNum || pageNumber, orderby, order, sortParameter);
			if (res.Data?.rows) {
				setDrawerFilterStatus(ESTATUSFILTER.INICIAL);
				if (res.Data?.rows?.length > 0)
				{
					setListaPaginada(res.Data?.rows);					
					if (res?.pager)
					{
						setPager(res?.pager);
						setPageNumber(res.pager.current_page);
						setRowsPerPage(res.pager.items_per_page);
					}
				}
				else
				{
					setListaPaginada([]);
					setPager(null);
					setPageNumber(1);
					bananinhaDelegate?.abrir('Nenhum resultado encontrado.', "error");
				}
			}
		}
		catch(e)
		{
			bananinhaDelegate?.abrir(e, "error");
		}
		finally
		{
			setEhCarregado(true);
		}
	}
	const getEdit = async (entidade:IFormStateEntidades) =>
	{
		try
		{
			const res:IRetornoAjaxEntidades = await EntController.seriesList(entidade.idSerie);
			if (res.status == 200 && res.Data) {
				entidade = res.Data as unknown as IFormStateEntidades
			}
			else {
				bananinhaDelegate?.abrir(res.message, "error");
			}
		}
		catch(e)
		{
			bananinhaDelegate?.abrir(e, "error");
		}
		finally
		{
			return entidade;
		}
	}

	React.useEffect(() =>
	{
		setDrawerFilterStatus(ESTATUSFILTER.FECHADO);
	},[ehCarregado])

	return <>
		<PageContext.Provider value={{ _handleAdd: _handleAdd, _handleEdit: _handleEdit, _handleExclude: _handleExclude, _handleView: _handleView }}>
			<Bananinha getDelegate={delegate => bananinhaDelegate ?? setBananinhaDelegate(delegate)}/>
			<AlertDialog getDelegate={delegate => alertConfirmDelegate ?? setAlertConfirmDelegate(delegate)}/>
			{(ehCarregado && listaPaginada && !deleting && drawerFilterStatus) ?
				<PageContext.Consumer>{ctx => (
					<ListComponent 
						titulo="Séries"
						addHandleAdd={() => ctx?._handleAdd()}
						addUrl={null}
						addEhNovaJanela={null}
						lstTipo={ETABLE.SERIES}
						lstListaPaginada={listaPaginada}
						lstPaginacao={pager}
						lstPageNumber={pageNumber}
						lstRowsPerPage={rowsPerPage}
						lstSetup={[
							// { id: 'idSerie',					numeric: false,	label: 'ID' },
							{ id: 'titulo',					numeric: false,	label: 'Título',						sort: true,	align: 'left' },
							{ id: 'tipoSerie',				numeric: false,	label: 'Tipo',							sort: true,	align: 'left' },
							{ id: 'numeroEpisodios',		numeric: false,		label: 'Episódios',					sort: true },
							{ id: 'anoProducao',				numeric: false,		label: 'Ano de produção',			sort: true },
							{ id: 'classificacaoEtaria',	numeric: false,	label: 'Classificação etária',	sort: true,	align: 'left' },
							// { id: 'sol',						numeric: false,	label: 'SOL',							sort: false },
							// { id: 'pjur',						numeric: false,	label: 'PJUR',							sort: false },
							{ id: 'dataCadastro',				numeric: false,	label: 'Cadastrado em',					sort: true },
							{ id: 'dataAlteracao',			numeric: false,	label: 'Alterado em',				sort: true }
						]}
						lstHandleEdit={(props) => ctx?._handleEdit(props)}
						lstHandleView={(props) => ctx?._handleView(props)}
						lstHandleDelete={(id, name) => ctx?._handleExclude(id, name)}
						lstFieldID="idSerie"
						lstFieldName="titulo"
						lstCallback={async (rowsNum, pageNum) => 
							{
							setEhCarregado(false);
							setRowsPerPage(rowsNum);
							setPageNumber(pageNum);
							await getList(undefined, rowsNum, pageNum, orderBy, order, filtroHead?.titulo);
							}}
						fltVisivel={true}
						fltTipoForm={ETIPOFILTER.SERIES}
						fltFilterDefault={dataFilter}
						fltStatus={drawerFilterStatus}
						fltFilterList={['titulo', 'anoProducao', 'idGenero', 'tipoSerie', 'idProdutora', 'classificacaoEtaria', 'sinopseSerie','elenco']}
						fltCallback={async (dataFilterReturn:IPropsFilterObj) => 
							{
							setPageNumber(1);
							if (dataFilterReturn && !areAllValuesEmpty(dataFilterReturn))
							{
								setDataFilter(dataFilterReturn);
								await getList(dataFilterReturn, undefined, 1, orderBy, order, filtroHead?.titulo);
							}										
							else if (dataFilterReturn && areAllValuesEmpty(dataFilterReturn))
							{
								setDataFilter(objFilterDefault);
								getList(objFilterDefault, undefined, 1, orderBy, order, filtroHead?.titulo);
							}
							else
								bananinhaDelegate?.abrir('Ocorreu um erro. Não foi possível filtrar.', "error");
							setDrawerFilterStatus(ESTATUSFILTER.FECHADO)
						}}
						lstOrderHeranca={order}
						lstOrderByHeranca={orderBy}
						lstCallbackFilter={async (event: React.MouseEvent<unknown>, filter: ITableFilter, orderBy?: string) =>
							{
								console.log('Filter clicked:', filter, orderBy);
								if (filter && orderBy) {
									setOrderBy(orderBy as ColumnTypes);
									setPageNumber(1);
									setFiltroHead(filter);
									if (filter.order === 'asc') {
										await getList(dataFilter, rowsPerPage, 1, orderBy, 'asc', filter?.titulo);
										setOrder(filter.order);
									}if (filter.order === 'desc') {
										await getList(dataFilter, rowsPerPage, 1, orderBy, 'desc', filter?.titulo);
										setOrder(filter.order);
									}
								}
							}
						}
					>
						<></>
					</ListComponent>
				)}</PageContext.Consumer>
				:
				<TableSkeleton />
			}
			{
				formEntidade &&
					<FormDialog
						operacao={formEntidade.idSerie ? EFORM.UPDATE : EFORM.ADD}
						entidade={formEntidade}
						setEntidade={setFormEntidade}
						listViews={formView}
						openDialog={openDialog}
						setOpenDialog={setOpenDialog}
						callBack={() => 
						{
							setEhCarregado(false);
							getList();
						}}
					/>
			}
		</PageContext.Provider>
	</>
}
export default ListaSeries;
